import React, { Component } from 'react';
import { connect } from 'react-redux';
import Paper from 'material-ui/Paper';
import HardwareKeyboard from 'material-ui/svg-icons/hardware/keyboard';
import './Signin.css';

const mapStateToProps = (state) => {
  return {
    fonts: state.fonts,
    fontSize: state.fontSize,
  }
}

class Signin extends Component {
  render() {

    const {
      fonts,
    } = this.props;


    const {
      primary,
      secondary
    } = fonts;

    const styles = {
      primaryFont: {
        fontFamily: primary.name,
      },
      secondaryFont: {
        fontFamily: secondary.name,
      },
    }

    return (
      <Paper
        zDepth={1}
        className="phone-wrapper">
        <div className="fake-sign-in-background">
          <HardwareKeyboard className="mixfont-sign-in-logo" />
          <div className="mixfont-sign-in-text"
            style={styles.primaryFont}>
            Mixfont
          </div>
          <div className="fake-sign-in-form-container"
            style={styles.secondaryFont}>
            <form autoComplete="off">
              <input placeholder="Enter your email"
                type="text"
                autoComplete="new-street-address"
                style={styles.secondaryFont} />
              <input
                placeholder="Type your password"
                type="password"
                autoComplete="new-password"
                style={styles.secondaryFont} />
            </form>
            <input type="checkbox" className="remember-me-checkbox" />
            <div className="remember-me-text"
              style={styles.secondaryFont}>Remember me</div>
          </div>
          <div className="fake-sign-in-button"
            style={styles.primaryFont}>
            Sign In Now
          </div>
          <div className="need-account"
            style={styles.secondaryFont}>
            Need an account? <b><u>Sign up</u></b>
          </div>
        </div>
      </Paper>
    )
  }
}

export default Signin = connect(mapStateToProps, undefined)(Signin);



// WEBPACK FOOTER //
// ./src/components/generator/elements/Signin.jsx